import { styled as styledMui, Box } from "@mui/material";

export const TabsContainer = styledMui(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "0.75rem",
  // borderBottom: `1px solid ${theme.palette.divider}`,
  width: "100%",
  [theme.breakpoints.down("lg")]: {
    overflowX: "auto",
    overflowY: "hidden",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
}));

export const TabButton = styledMui(Box)<{
  active?: boolean;
  disabled?: boolean;
}>(({ theme, active, disabled }) => ({
  position: "relative",
  padding: "0.5rem",
  cursor: disabled ? "not-allowed" : "pointer",
  fontSize: "0.875rem",
  fontWeight: active ? 700 : 500,
  color: active
    ? theme.palette.primary.main
    : disabled
      ? theme.palette.text.disabled
      : theme.palette.text.primary,
  opacity: disabled ? 0.5 : 1,
  transition: "all 0.15s ease",
  whiteSpace: "nowrap",
  borderBottom: `2px solid ${active ? theme.palette.primary.main : theme.palette.divider}`,
  "&:hover": disabled
    ? {}
    : {
        color: active ? theme.palette.primary.main : theme.palette.text.primary,
      },
}));
